import { Row, Col } from 'components/Base/Grid';
import { Icon, TIconNames } from 'components/Base/Icon';
import { Title } from 'components/Base/Typography';
import Button, { EButtonTypes } from 'components/Base/Button';
import { Colors, FontWeights } from 'core/CssVariables';
import styled from 'styled-components';

const ErrorFallback = () => {
  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <SErrorRow justify="center" align="middle">
      <Col xs={22} sm={16} md={12} lg={8}>
        <SIconCircle>
          <Icon
            icon={TIconNames.CLOSE_ROUND}
            size={40}
            color={Colors.ErrorColor}
          />
        </SIconCircle>
        <Title
          fontLevel={2}
          fontWeight={FontWeights.Medium}
          color={Colors.Black}
        >
          Something went wrong
        </Title>
        <SDescription>
          An unexpected error occurred. Please try reloading the page. If the
          problem persists, contact support.
        </SDescription>
        <Row gutter={[16, 0]} justify="center">
          <Col xs={12}>
            <Button onClick={handleReload} className="w-100">
              Reload Page
            </Button>
          </Col>
          <Col xs={12}>
            <Button
              onClick={handleGoHome}
              type={EButtonTypes.Default}
              className="w-100"
            >
              Go to Home
            </Button>
          </Col>
        </Row>
      </Col>
    </SErrorRow>
  );
};

export default ErrorFallback;

export const SErrorRow = styled(Row)`
  min-height: 100vh;
  text-align: center;
`;

export const SIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${`${Colors.ErrorColor}14`};
  margin: 0 auto 24px;
`;

export const SDescription = styled.p`
  color: ${Colors.DarkGrey};
  font-size: 14px;
  line-height: 22px;
  margin: 16px 0 32px;
`;
